//import { fade } from '@material-ui/core/styles/colorManipulator';
import {grey} from '@material-ui/core/colors';
import background from '../../../../../../assets/Home/background1.jpg';

const styles = (theme) => ({
    background:{
        position:'absolute',
        backgroundImage: `url(${background})`,
        width:'100%',
        height: '100%',
        backgroundSize: "cover",
        backgroundPosition: "center center",
        zIndex:-1,
        "&:after": {
            position: "absolute",
            zIndex: "3",
            width: "100%",
            height: "100%",
            content: '""',
            display: "block",
            background: 'rgba(0,0,0,0.8)'
        }
    },
    section:{
        padding:'100px 0px',
        background:grey[50]
    },
    container:{
        boxSizing:'border-box',
        width:'100%',
        margin:'auto',
        padding:'8px 16px',
    },
    subcontainer:{
        position:'relative',
    },
    lineContainer:{
        position:'absolute',
        width:'100%',
        height:'100%',
    },
    line:{
        width:'2px',
        height:'100%',
        background:grey[300],
        zIndex:10,
        marginLeft:'33px'
    },
    divider:{
        marginTop:'32px',
        width:'50px',
        minHeight:'5px',
        background:grey[300]
    },
    about_title:{
        fontWeight:'700',
        maxWidth:'500px'
    },
    about_content_container:{
        margin:'8px'
    },
    about_content:{
        color:grey[200],
        fontWeight:'700',
        fontSize:'4.5em'
    },
    button:{
        background:'#4b6bf5',
        color:'white',
        padding:'12px 28px',
        borderRadius:'24px',
        textTransform:'none',
        fontSize:'1em',
        fontWeight:'600',
        '&:hover':{
            background:'#4b6bf5',
            boxShadow:'0 10px 20px rgba(75, 107, 245, 0.16), 0 6px 6px rgba(75, 107, 245, 0.23)'
        }
    },
})

export default styles;